import { RawMaterialMasterThemeSizeConfig } from './types';

const large: RawMaterialMasterThemeSizeConfig = {
  rawMaterialMaster: {},
};

export default large;
